import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { RequestHelper } from "../../Lib/Helper/RequestHelper";
import { AxModal, AxDropdown, AxFormValidation, AxInput } from "@axess/limestone";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { AccountStorageService } from "../../Service/Account/AccountStorageService";
import { AxButton } from "../../Limestone/AxButton/AxButton";
import { ConsentDocuments, ICheckboxInfo } from "../ConsentDocuments/ConsentDocuments"

@ModuleName("RegisterForm")
export class RegisterForm implements AxInit {

    protected _i18nHelper = new I18nHelper();
    localLinks: any;
    consentDocumentModule: ConsentDocuments;

    constructor(private _requestHelper = new RequestHelper(),
        protected _axButton = new AxButton(),
        private _storage = new AccountStorageService()) { }

    AxInit(init: any): void {
        new AxModal().init();
        new AxInput('#password').init();
        new AxInput('#mail').init();
        new AxInput('#login-email').init();

        this.consentDocumentModule = AxLoad.GetModule<ConsentDocuments>("ConsentDocuments");

        $("#registration__rentalContainer").hide();
        $("#registration__rentalContainer-submit").hide();
        $("#registration__checkInboxWrapper").hide();
        $("#forget-password__checkInboxWrapper").hide();
        $("#registerResponseField").hide();
        $("#normalForm").show();

        $("#mail").on("keyup", function () {
            $("#registerResponseField").hide();
        });

        $("#height").on("keyup", function () {
            $('#height').inputmask("999", {
                placeholder: " ",
                greedy: false
            });
        });

        //StandardForm
        new AxFormValidation({
            selector: '#register-form',
            rules: this.getValidationRules(),
            callback: (form: HTMLElement) => {
                if (this.hasRental()) {
                    this.toggleRental(true);
                    return;
                }

                this.saveConsentsRegister(form);
            }
        }).init();

        //LoginForm
        new AxFormValidation({
            selector: '#loginForm',
            rules: {},
            callback: () => {
                this.login();
            }
        }).init();


        //RentalForm
        new AxFormValidation({
            selector: '#register-form__rental',
            //Rental validation rules goes here:
            rules: this.getValidationRules(),
            callback: (form: HTMLElement) => {
                this.saveConsentsRegister(form);
            }
        }).init();

        $(`[data-registration="rental_back"]`).on("click", () => {
            $("#registration__rentalContainer").hide();
            $("#registration__rentalContainer-submit").hide();
            $("#registration__checkInboxWrapper").hide();
            $("#forget-password__checkInboxWrapper").hide();
            $("#registerResponseField").hide();
            $("#RegForm").show();
            $("#normalForm").show();
        });

        $("#form-resetPass").on("submit", (event) => {
            event.preventDefault();
            this.resetPassword();
        });
    }

    checkStoredForward() {
        let storageData = this._storage.getStorage();
        if (storageData != null) {
            if (storageData.data != null) {
                this._requestHelper.postToUrl(storageData.target, storageData.data);
            } else {
                location.href = storageData.target;
            }
            return true;
        }

        return false;
    }


    login() {
        $('#loginResponseField').html('').addClass('d-none');
        this._axButton.Loading($('[data-account="wrapper"] button[type="submit"]')[0]);

        AxessViewer.loadPartialView('/Account/Login',
            {
                Email: $('#loginForm #login-email').val(),
                Password: $('#loginForm #password').val(),
                LoginTypeNr: $('#LoginTypeNr').val(),
                ReturnUrl: $('#ReturnUrl').val()

            },
            (resp: any) => {
                if (typeof resp['nErrorCode'] == 'undefined' && resp.success) {
                    let storageForward = this.checkStoredForward();
                    if (storageForward) return;

                    if (typeof resp.WebhookLoginToken != 'undefined' && resp.WebhookLoginToken != null) {
                        notifyAppLogin(resp.WebhookLoginToken);
                    } else {
                        if (typeof resp.returnUrl != 'undefined' && resp.returnUrl != null) {
                            location.href = "/" + resp.languageCode + "/" + resp.returnUrl + "/";
                        }
                        else {
                            location.href = "/" + resp.languageCode + "/Products/Tickets/";
                        }

                    }
                    return;
                }

                if (typeof resp['response'] != 'undefined') {
                    $('#loginResponseField').html(resp['response']).removeClass('d-none');
                } else if (typeof resp['message'] != 'undefined') {
                    $('#loginResponseField').html(resp['message']).removeClass('d-none');
                } else if (typeof resp['szErrorMessage'] != 'undefined') {
                    $('#loginResponseField').html(resp['szErrorMessage']).removeClass('d-none');
                }

                this._axButton.StopLoading($('[data-account="wrapper"] button[type="submit"]')[0]);
            }
            , {});

    }

    toggleRental(show: boolean) {
        if (show) {
            $("#registration__rentalContainer").show();
            $("#registration__rentalContainer-submit").show();
            $("#RegForm").hide();
            return;
        }
        $("#registration__rentalContainer").hide();
        $("#registration__rentalContainer-submit").hide();
        $("#RegForm").show();
        $("#normalForm").show();
    }

    hasRental() {
        return $('#register-form__rental').length > 0;
    }

    saveConsentsRegister(form: HTMLElement) {
        if (this.consentDocumentModule.consentNeeded) {
            let consentDeliveryInfo = {
                shoppingCartId: 0,
                isGuestCheckOut: false,
                customerAccountNo: 0,
                consentCheckboxInfos: this.consentDocumentModule.checkBoxInfos
            }
            
            this.register(form, consentDeliveryInfo);
        } else {
            this.register(form, null);
        }
    }

    resetPassword() {
        const email = $('#forget-pass-email').val().toString();
        this._axButton.Loading($('[data-account="wrapper"] button[type="submit"]')[0]);

        AxessViewer.loadPartialView(`/Account/ResetPassword/`, { "email": email }, (result) => {
            $('[data-account="wrapper"]').html(result.view);
            this._axButton.StopLoading($('[data-account="wrapper"] button[type="submit"]')[0]);
        }, { reload: false, silent: true });
    }

    getValidationRules(): JQueryValidation.RulesDictionary {
        return {
            radio: {
                required: true,
            },
            radioMd: {
                required: true,
            },
            lastname: {
                required: true,
            },
            dropdown: {
                required: true,
            },
            hiddenPhone: {
                required: true,
                regex: /([0-9]{10})|(\([0-9]{3}\)\s+[0-9]{3}\-[0-9]{4})/
            },
            phone: {
                required: true,
                regex: /([0-9]{10})|(\([0-9]{3}\)\s+[0-9]{3}\-[0-9]{4})/,
                normalizer: function (value) {
                    let dropdownVal = $(this).parents(".ax-phone-field").find(".hidden-input").val() as string;
                }
            },
            password: {
                required: true,
            },
            passwordValidation: {
                required: true,
                pwcheck: true,
                minlength: 8,
            },
            email: {
                required: true,
                email: true,
                regex: /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i,
            },
            registrationConfirmMail: {
                equalTo: "#mail"
            },
            checkboxTerms: {
                required: true,
            },
            emailconfirm: {
                required: true,
                equalTo: "#guest-email",
            },
            PasswordConfirm: {
                required: true,
                equalTo: "#password",
            }
        };
    }

    register(element: HTMLElement, consentDeliveryInfo) {
        let termsCheck = $(element).find('input[name=TermsAndConditions]');

        if (termsCheck.length) {
            $(termsCheck).parent().removeClass('invalid');

            if (termsCheck.prop('checked') == false) {
                $(termsCheck).parent().addClass('invalid');
            }
        }

        let addCheck = $(element).find('.registration_addB');

        if (addCheck.length > 0) {
            addCheck.each(function (index, elem) {
                if ($(elem).prop('checked') == false) {
                    $(elem).parent().addClass('invalid');
                } else {
                    $(elem).parent().removeClass('invalid');
                }
            });
        }

        if (consentDeliveryInfo != null) {
            let temp = consentDeliveryInfo.consentCheckboxInfos;

            jQuery.each(temp, function (i, val) {
                $('#register-form').append('<input hidden name="ConsentCheckboxInfos[' + i.toString() + '].DocumentId" value="' + val.documentId + '" /> ');
                $('#register-form').append('<input hidden name="ConsentCheckboxInfos[' + i.toString() + '].IsChecked" value="' + val.isChecked + '" /> ');
            });
        }

        let baseForm = this._requestHelper.objectifyForm($('#register-form').serializeArray());

        if (this.hasRental()) {
            let rentalForm = this._requestHelper.objectifyForm($('#register-form__rental').serializeArray());
            baseForm = { ...baseForm, ...rentalForm };
        }

        $('[data-account="wrapper"] button[type="submit"]').each((i, e) => {
            this._axButton.Loading(e);
        });

        const languages = $(element).find('button[type=submit]').data('languages') || [];
        let languageCode;
        if (languages.length > 0) {
            languageCode = languages.filter((l) => l.SprachID == $('#Language').val());
            languageCode = languageCode.length > 0 ? languageCode[0].IsoSprachCode : null;
        }

        AxessViewer.loadPartialView('/Account/Register', baseForm, (resp) => {
            if (typeof resp['success'] != 'undefined' && resp['success'] == true) {
                let storageForward = this.checkStoredForward();
                if (storageForward) return;

                if (typeof resp.WebhookLoginToken != 'undefined' && resp.WebhookLoginToken != null) {
                    notifyAppLogin(resp.WebhookLoginToken);
                }
                $('#registerResponseField').html('');

                $("#normalForm").hide();

                if (resp.activationRequired) {
                    //@ts-ignore
                    AxessViewer.loadPartialView('/Account/LoadCheckInbox', { email: baseForm.email },
                        (resp) => {
                            $('[data-account="wrapper"]').html(resp.view);
                        },
                        {});
                }
                window.location.href = languageCode ? `/${languageCode}/Home` : "/Home";
                return;
            } else {
                $('[data-account="wrapper"] button[type="submit"]').each((i, e) => {
                    this._axButton.StopLoading(e);
                });
                $("#registration__rentalContainer").hide();
                $("#registration__rentalContainer-submit").hide();
                $("#registration__checkInboxWrapper").hide();
                $("#register-form").show();
                $("#RegForm").show();
                $("#normalForm").show();
                $('#registerResponseField').show();
                if (typeof resp['response'] != 'undefined') {
                    $('#registerResponseField').html(resp['response']);
                } else if (typeof resp['message'] != 'undefined') {
                    $('#registerResponseField').html(resp['message']);
                } else if (typeof resp['szErrorMessage'] != 'undefined') {
                    $('#registerResponseField').html(resp['szErrorMessage']);
                }
                $('#registerResponseField').addClass('ax-mb-2 ax-alert ax-alert--inline ax-alert--info');
                window.scrollTo(0, 0);
            }
        }, { silent: true });

    }
}